import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Exercise } from "../types/ExerciseTypes";
import { useTranslations } from "@/hooks/useTranslations";

interface ExerciseFieldsProps {
  exercise: Exercise;
  exerciseIndex: number;
  dayIndex: number;
  isCardio: boolean;
  onUpdateExercise: (dayIndex: number, exerciseIndex: number, field: keyof Exercise, value: string | number | string[]) => void;
}

export function ExerciseFields({ 
  exercise, 
  exerciseIndex, 
  dayIndex, 
  isCardio,
  onUpdateExercise 
}: ExerciseFieldsProps) {
  const { t } = useTranslations("workouts");
  
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-3 mt-1 mb-1">
      <div className="space-y-1">
        <label className="text-xs text-muted-foreground">{t("newWorkout.exercises.sets")}</label>
        <Input 
          type="number"
          min="1"
          value={exercise.sets || ""}
          onChange={(e) => onUpdateExercise(dayIndex, exerciseIndex, "sets", Number(e.target.value))}
          className="h-8 bg-white"
        />
      </div>

      <div className="space-y-1">
        <label className="text-xs text-muted-foreground">
          {isCardio ? t("newWorkout.exercises.time") : t("newWorkout.exercises.reps")}
        </label>
        <Input 
          value={isCardio ? (exercise.time || "") : (exercise.reps || "")}
          onChange={(e) => {
            const field = isCardio ? "time" : "reps";
            onUpdateExercise(dayIndex, exerciseIndex, field, e.target.value);
          }}
          placeholder={isCardio ? "ex: 30s, 1min" : "ex: 8-12, 15"}
          className="h-8 bg-white"
        />
      </div>

      {!isCardio && (
        <div className="space-y-1">
          <label className="text-xs text-muted-foreground">{t("newWorkout.exercises.weight")}</label>
          <Input 
            value={exercise.weight || ""}
            onChange={(e) => onUpdateExercise(dayIndex, exerciseIndex, "weight", e.target.value)}
            placeholder="ex: 10, 10-12kg"
            className="h-8 bg-white"
          />
        </div>
      )}

      <div className="space-y-1">
        <label className="text-xs text-muted-foreground">{t("newWorkout.exercises.rest")}</label>
        <Input 
          value={exercise.rest || ""}
          onChange={(e) => onUpdateExercise(dayIndex, exerciseIndex, "rest", e.target.value)}
          placeholder="ex: 30s, 1min"
          className="h-8 bg-white"
        />
      </div>
    </div>
  );
}
